import { Link } from 'react-router-dom'

const socialLinks = [
  { name: 'Instagram', href: 'https://www.instagram.com/sudhas_makeup_artist', ariaLabel: 'Follow Sudha\'s Academy on Instagram' },
  { name: 'YouTube', href: 'https://www.youtube.com/@sudhasmakeupacademy', ariaLabel: 'Subscribe to Sudha\'s Academy YouTube channel' },
  { name: 'Facebook', href: 'https://facebook.com/sudhasacademy', ariaLabel: 'Like Sudha\'s Academy on Facebook' },
]

const footerLinks = [
  { name: 'Privacy Policy', href: '/privacy-policy' },
  { name: 'Terms of Service', href: '/terms-of-service' },
]

export default function Footer() {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer 
      className="relative z-50 bg-charcoal-900 dark:bg-black border-t border-white/5 dark:border-white/10 transition-colors duration-500"
      role="contentinfo"
      itemScope
      itemType="https://schema.org/WPFooter"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-20 py-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
          {/* Logo & Copyright */}
          <div itemScope itemType="https://schema.org/Organization">
            <Link 
              to="/" 
              className="text-white text-2xl font-serif font-bold tracking-tight block mb-3 hover:text-rose-500 transition-colors"
              itemProp="url"
              aria-label="Sudha's Academy - Home"
            >
              <span itemProp="name">SUDHA'S ACADEMY</span>
            </Link>
            <p className="text-charcoal-400 text-sm font-mono">
              © {currentYear} <span itemProp="legalName">Sudha's Academy</span>. All rights reserved.
            </p>
            <meta itemProp="logo" content="https://sudhasacademy.com/Logo.png" />
            <meta itemProp="description" content="India's premier beauty and makeup training institute since 2006" />
          </div>

          {/* Social Links */}
          <nav aria-label="Social media links">
            <ul className="flex gap-8">
              {socialLinks.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-charcoal-400 text-sm font-mono uppercase tracking-[0.15em] hover:text-rose-500 transition-colors cursor-pointer"
                    aria-label={social.ariaLabel}
                    itemProp="sameAs"
                  >
                    {social.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Legal Links */}
          <nav aria-label="Legal pages">
            <ul className="flex gap-8">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-charcoal-400 text-sm font-mono hover:text-rose-500 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        
        {/* Additional SEO content - hidden visually but accessible */}
        <div className="sr-only">
          <p>
            Sudha's Academy is India's leading beauty and makeup training institute located in Tamil Nadu.
            We offer professional courses in bridal makeup, skincare, hair styling, nail art, and cosmetology.
            Founded by Dr. Sudha M in 2006, we have trained over 15,000 successful beauty professionals.
          </p>
        </div>
      </div>
    </footer>
  )
}